<template>
  <div class="o-plate">
    <o-icon
      icon="chevron-right"
      class="o-plate__toggle"
      :class="{
        'o-plate__toggle--open': !isCollapsed
      }"
      @click.native="toggleCollapse"
    />
    <o-icon
      v-if="!isCollapsed"
      icon="minus"
      class="o-plate__remove"
      @click.native="removePlate"
    />
    <o-section v-if="isCollapsed" @click.native="toggleCollapse">{{
      label
    }}</o-section>
    <template v-if="!isCollapsed">
      <o-section>
        <o-text-input label="License Plate Name" :value="label" />
      </o-section>
      <o-section>
        <o-text-input label="License Plate Number" :value="plateNumber" />
      </o-section>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    collapsed: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    plateNumber: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isCollapsed: true
    }
  },

  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },

    removePlate() {
      if (
        window.confirm('Are you sure you want to remove this license plate?')
      ) {
        this.isCollapsed = true
      }
    }
  },

  created() {
    this.isCollapsed = this.collapsed
  }
}
</script>

<style lang="scss">
.o-plate {
  position: relative;
}

.o-plate__toggle {
  cursor: pointer;
  position: absolute;
  right: 1.2rem;
  top: 1.2rem;
  z-index: 5;
}

.o-plate__toggle--open {
  transform: rotate(90deg);
}

.o-plate__remove {
  cursor: pointer;
  position: absolute;
  right: 4.8rem;
  top: 1.2rem;
  z-index: 5;
}
</style>
